import { createContext, useContext, useEffect, useState } from "react";
import { dict, LANGS, DEFAULT_LANG } from "@/i18n/dict";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("pig-lang") || DEFAULT_LANG);

  useEffect(() => {
    localStorage.setItem("pig-lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = (path) => {
    const value = path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), dict[lang]);
    if (value != null) return value;
    const fallback = path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), dict.en);
    return fallback != null ? fallback : path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
